module.exports = __webpack_public_path__ + "static/media/blockchain.62bdd12b.svg";